module.exports = __webpack_public_path__ + "img/contact_check.8b607666.svg";